import CorporatePage from '../components/CorporatePage'
import { CORPORATE_I18N } from '../data/corporate-i18n'

// Anchor ids match the EXISTING navbar corporate-dropdown hrefs (TR).
const ANCHORS = {
    about: 'about',
    vision: 'vizyon',
    values: 'degerler',
    quality: 'kalite',
    certifications: 'sertifikalar'
}

const LANG_LINKS = { tr: '/kurumsal', en: '/en/corporate', de: '/de/unternehmen' }

const JSON_LD = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: CORPORATE_I18N.tr.seo.title,
    description: CORPORATE_I18N.tr.seo.description,
    url: 'https://ankaplastik.com/kurumsal',
    inLanguage: 'tr',
    about: {
        '@type': 'Organization',
        '@id': 'https://ankaplastik.com/#organization',
        name: 'Ankaplastik'
    }
}

export default function Kurumsal() {
    return (
        <CorporatePage
            lang="tr"
            data={CORPORATE_I18N.tr}
            langLinks={LANG_LINKS}
            canonicalUrl="/kurumsal"
            contactHref="/#contact"
            skipLabel="İçeriğe geç"
            anchors={ANCHORS}
            jsonLd={JSON_LD}
        />
    )
}
